var _defs, _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew217({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}.b{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 0.92,
    y: 3.16,
    width: 14.16,
    height: 9.67
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1.69,9.79a2.56,2.56,0,0,0,1.3.37c.75,0,1.18-.39,1.18-1s-.3-.83-1.06-1.12c-.92-.33-1.49-.81-1.49-1.6A1.62,1.62,0,0,1,3.44,5a2.47,2.47,0,0,1,1.25.28l-.2.59a2.26,2.26,0,0,0-1.07-.27c-.77,0-1.06.46-1.06.85s.34.78,1.12,1.08c.95.37,1.43.83,1.43,1.66s-.64,1.62-2,1.62A2.93,2.93,0,0,1,1.5,10.4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M6.82,8.91l-.58,1.77H5.49L7.4,5h.88l1.92,5.64H9.42l-.6-1.77Zm1.85-.57L8.12,6.71a10.08,10.08,0,0,1-.29-1h0c-.08.33-.18.67-.28,1L7,8.34Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M11,5.11A8.25,8.25,0,0,1,12.43,5,2.33,2.33,0,0,1,14,5.47a1.52,1.52,0,0,1,.49,1.18,1.66,1.66,0,0,1-.43,1.2,2.35,2.35,0,0,1-1.73.62,2.61,2.61,0,0,1-.58-.05v2.26H11Zm.73,2.72a2.58,2.58,0,0,0,.6,0c.88,0,1.41-.42,1.41-1.2s-.52-1.1-1.32-1.1a2.68,2.68,0,0,0-.69.06Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew217);
export default __webpack_public_path__ + "static/media/Symbolpack_New_217.f0ec842eb2b02abab58eaac5e46587e5.svg";
export { ForwardRef as ReactComponent };